import { status } from "skin/event/status";
import table from "./table";
import api from "skin/http";

//Отправка запроса на сервер и получение данных для отрисовки таблицы
const msState = (obj, ms, story, data, d, action) => {
  if (obj.action === "loadData")
    return new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: "api/other/master/getPc",
      };
      api(config)
        .then((res) => {
          // if (data.curData.values.table.tnk_state.list.length) return resolve(status.action);
          const arr = [];
          //   для отображения строк в таблице
          res.data.forEach((el) => {
            if (el?.state?.on) arr.push(el?.ip);
            // "", el._id, el?.ip, el?.cmp, el.bld - чек, id терминала(скрыто), ip терминала, привязка к компании терминала, привязка к складу терминала
            data.addRow(ms, "tnk_state", { key: el._id, list: ["", el._id, el?.ip, el?.cmp ?? "", `${el.bld}`] });
          });
          //   для подстановки "" или "+" в первой строке в зависимости есть ли запись state в данных
          const check = data.curData.values.fld.ip;
          data.curData.values.table.tnk_state.list.forEach((el) => {
            const ip = el?.list[2];
            if (check.includes(ip)) {
              if (arr.includes(ip)) data.setCell("tnk_state", el.key, 0, "+");
              else data.setCell("tnk_state", el.key, 0, "");
            }
          });
          return resolve(status.action);
        })
        .catch((err) => {
          return resolve(status.action);
        });
    });
  switch (obj.type) {
    case "table":
      return table(obj, ms, story, data, d, action);
    default:
      return status.action;
  }
};

export default msState;
